import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';
import b from 'b_';
import { ZenLogo } from '../Logo/PfptLogo';
import './BrowserPopUp.css';

const block = b.lock('BrowserPopUp');

export default function BrowserPopUp(props) {
    const {
        title,
        onClose,
        overlayClassName,
        className,
        bodyClassName,
        customHeader,
        footerActions,
        ...otherProps
    } = props;

    let children = props.children;

    if (children) {
        children = React.Children.map(children, (el) => {
            if (el) {
                return React.cloneElement(el, { onClose });
            }
            return el;
        });
    }

    const defaultHeader = (
        <ZenLogo
            mainColor="var(--black0, #171B27)"
            className={block('Logo')}
        />
    );

    return <ReactModal
        className={cn(block('Wrapper'), className)}
        overlayClassName={cn(block('Overlay'), overlayClassName)}
        ariaHideApp={false}
        {...otherProps}
    >
        <div className={block('Content')}>
            <div className={block('Header')}>
                {customHeader || defaultHeader}
            </div>
            {title ? <div className={block('Title')}>{title}</div> : null}
            <div className={cn(block('Body'), bodyClassName)}>
                {children}
            </div>
            {footerActions && <div className={block('Footer')}>{footerActions}</div>}
        </div>
    </ReactModal>;
}

BrowserPopUp.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    overlayClassName: PropTypes.string,
    customHeader: PropTypes.node,
    footerActions: PropTypes.node,
    children: PropTypes.node,
    ...ReactModal.propTypes,
};
